var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExerciseSliderIconWhite2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.8 95.5",
    style: {
      enableBackground: "new 0 0 115.8 95.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6A8BE5;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\n\t\n\t\t.st4{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:3.9248,3.9248,1.0902,3.9248;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:9.8371,9.8371;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:4.0826;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:4.3666;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.8,39.4c4.8-10.7,15.6-18.2,28.1-18.2c16.9,0,30.7,13.8,30.7,30.7S86.7,82.5,69.8,82.5 c-12.5,0-23.3-7.5-28.1-18.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.9,9.2v4.4c-2-0.3-4-0.5-6.1-0.5c-2,0-3.9,0.1-5.8,0.4V9.2C64.1,6.9,66,5,68.3,5h3.3 C74,5,75.9,6.9,75.9,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.2,39.4c2.5-7.3,7-13.6,13-18.2c1-0.8,2.1-1.6,3.3-2.3c4.4-2.7,9.3-4.6,14.6-5.4c1.9-0.3,3.8-0.4,5.8-0.4 c2.1,0,4.1,0.2,6.1,0.5c5.2,0.8,10,2.7,14.3,5.3c1.1,0.7,2.2,1.5,3.3,2.3c9.2,7.1,15,18.2,15,30.6c0,21.4-17.3,38.7-38.7,38.7 c-17,0-31.5-11-36.7-26.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.4,18.9c-1.1,0.7-2.2,1.5-3.3,2.3l-2.7-2.7c-0.8-0.8-0.8-2,0-2.7l0.1,0c0.8-0.8,2-0.8,2.7,0L49.4,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.2,18.5l-2.7,2.7c-1-0.8-2.1-1.6-3.3-2.3l3.2-3.2c0.8-0.8,2-0.8,2.7,0l0,0C96.9,16.5,96.9,17.8,96.2,18.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 25.7,
    y1: 44.1,
    x2: 33.2,
    y2: 44.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 38.9,
    y1: 44.1,
    x2: 46.4,
    y2: 44.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 14.2,
    y1: 52,
    x2: 23.2,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 24.3,
    y1: 52,
    x2: 35.2,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 37.1,
    y1: 52,
    x2: 46.1,
    y2: 52
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 6.5,
    y1: 60,
    x2: 11.5,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 21.3,
    y1: 60,
    x2: 36.1,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 41,
    y1: 60,
    x2: 46,
    y2: 60
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M56.7,51.7c0-4.7,2.9-9.6,8.2-9.6c2.4,0,3.8,0.7,3.8,0.7l-1.1,3.6c0,0-1.1-0.5-2.4-0.5c-2,0-3.1,1.2-3.6,2.8h0 c0.4-0.3,1.5-0.6,2.3-0.6c3.6,0,5.6,2.9,5.6,5.9c0,2.9-2.1,5.8-5.9,5.8C60.2,59.8,56.7,57.2,56.7,51.7z M63.7,55.9 c1.1,0,1.7-0.9,1.7-1.9c0-1.2-0.7-2.5-2.6-2.5c-0.9,0-1.7,0.2-1.7,1C61.1,54.6,62.5,55.9,63.7,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M71,50.9c0-4.9,1.6-8.8,6.5-8.8c4.9,0,6.5,3.9,6.5,8.8c0,4.9-1.6,8.9-6.5,8.9C72.5,59.8,71,55.8,71,50.9z  M79.5,50.9c0-2.8-0.5-5-2.1-5s-2.1,2.2-2.1,5c0,2.8,0.5,5.1,2.1,5.1S79.5,53.7,79.5,50.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseSliderIconWhite2);
export default __webpack_public_path__ + "static/media/exercise_slider_icon_white_2.d5a1d418.svg";
export { ForwardRef as ReactComponent };